import { Action, defaultActions } from '#/common/components/DataGrid';
import { Location } from '#/graphql/types';

export const actions: Action<Location>[] = [...defaultActions];
